import React from 'react';
import { NavLink } from 'react-router-dom';
import { HouseDoorFill, BellFill, BriefcaseFill, PeopleFill, Bank, GearFill, Diagram2Fill, 
    FileEarmarkBarGraphFill, ShieldShaded, Search, JournalCheck, ClipboardDataFill, 
    Table, KeyFill, Sliders,Speedometer2,DatabaseFill,Diagram3Fill,ShareFill  } from 'react-bootstrap-icons';
import { usePermissions } from '../../hooks/usePermissions';
// import './Sidebar.css';
import '../../App.css'; // Import the new stylesheet
import { useUI } from '../../context/UIContext'; // <-- IMPORT UI CONTEXT

const Sidebar = () => {
    const { permissions } = usePermissions(); // CORRECT: De-structure the hook's return value
    const { isSidebarCollapsed } = useUI(); // <-- USE THE COLLAPSED STATE

    return (
        <aside className={`sidebar d-flex flex-column ${isSidebarCollapsed ? 'collapsed' : ''}`}>
            <NavLink to="/dashboard" className="d-flex align-items-center ms-3 mt-3 mb-2 text-white text-decoration-none sidebar-brand">
                <ShieldShaded size={32} className="me-3" color='#0d6efd'/>
                <span className="fs-4 sidebar-logo me-2"> AML PRO</span>
            </NavLink>
            <hr />
            <ul className="nav nav-pills flex-column mb-auto ps-2">
                <li className="nav-item"><NavLink to="/dashboard" className="nav-link"><HouseDoorFill /><span>Dashboard</span></NavLink></li>
                <li className="nav-item"><NavLink to="/alert-queue" className="nav-link"><BellFill /><span>Alert Queue</span></NavLink></li>
                <li><NavLink to="/case-management" className="nav-link"><BriefcaseFill /><span>Case Management</span></NavLink></li>
                <li><NavLink to="/risk-management" className="nav-link"><Speedometer2 /><span>Risk Management</span></NavLink></li>
                <li><NavLink to="/user-administration" className="nav-link"><PeopleFill /><span>User Administration</span></NavLink></li>
                
                <li className="nav-item mt-3"><small className="text-muted ps-3"><span>System Tools</span></small></li>
                {/* <li><NavLink to="/demo-data" className="nav-link"><DatabaseFill /><span>Demo Data Generator</span></NavLink></li> */}
                <li><NavLink to="/system-simulator" className="nav-link"><DatabaseFill /><span>System & Data Simulator</span></NavLink></li>
                <li><NavLink to="/link-analysis" className="nav-link"><Diagram3Fill /><span>Link Analysis</span></NavLink></li>
                <li><NavLink to="/integrations" className="nav-link"><ShareFill /><span>API Integrations</span></NavLink></li>
                {/* <li><NavLink to="/transaction-generator" className="nav-link"><Bank /><span>Transaction Generator</span></NavLink></li> */}
                <li><NavLink to="/transaction-analysis" className="nav-link"><Table /><span>Transaction Analysis</span></NavLink></li>
                <li><NavLink to="/rule-engine" className="nav-link"><GearFill /><span>Rule Engine</span></NavLink></li>
                <li><NavLink to="/automation-studio" className="nav-link"><Sliders /><span>Automation & AI</span></NavLink></li>
                <li><NavLink to="/data-mapping" className="nav-link"><Diagram2Fill /><span>Data Mapping</span></NavLink></li>
                <li><NavLink to="/reporting" className="nav-link"><FileEarmarkBarGraphFill /><span>Reporting</span></NavLink></li>
                <li><NavLink to="/screening-studio" className="nav-link"><Search /><span>Screening Studio</span></NavLink></li>
                <li><NavLink to="/audit-log" className="nav-link"><JournalCheck /><span>Audit Log</span></NavLink></li>
                <li><NavLink to="/masters" className="nav-link"><ClipboardDataFill /><span>Masters</span></NavLink></li>
                
                {permissions.isAdmin && (
                    <li><NavLink to="/permission-management" className="nav-link"><KeyFill /><span>Permissions</span></NavLink></li>
                )}
            </ul>
            <hr />
            <div className="sidebar-footer text-center">
                <small>&copy; 2025 AML Pro System</small>
            </div>
        </aside>
    );
};

export default Sidebar;